<!-- TODO: out of use. consider to update or remove some info from ADD_RECEIPT -->
<template>
    <div>

        <div class="box box-primary">

            <div class="box-header with-border">

                <h3 class="box-title">Thông Tin Phiếu Xuất</h3>

            </div>


            <form class="form-horizontal">

                <div class="box-body">

                    <div class="col-md-6">

                        <!-- BEGIN - invoice_number From -->

                        <div class="form-group">

                            <label for="name" class="col-sm-3 control-label">{{$t('receipt.customer')}}</label>

                            <div class="col-sm-9">

                                <input v-model="receipt_data.payer" type="text" class="form-control" id="resident_fullname" :disabled="this.$route.params.id == 0 ? false : true" >

                            </div>

                        </div>

                        <!-- END - invoice_number From -->

                    </div>



                    <div class="col-md-6">

                        <!-- BEGIN - status_name From -->

                        <div class="form-group">

                            <label for="date_paid" class="col-sm-3 control-label">{{$t('receipt.receipt_created')}}</label>

                            <div class="col-sm-9">

                                <div class="input-group date">

                                    <div class="input-group-addon">

                                        <i class="fa fa-calendar"></i>

                                    </div>

                                    <date-picker v-model="form.reciept_date_issued" :config="options" :disabled="this.$route.params.id == 0 ? false : true"></date-picker>

                                </div>

                            </div>

                            <!-- /.input group -->

                        </div>

                        <!-- END - status_name From -->

                    </div>



                    <div class="col-md-6" >

                        <!-- BEGIN - date_issued From -->

                        <div class="form-group">

                            <label for="name" class="col-sm-3 control-label">{{$t('receipt.actual_amount_title')}}</label>

                            <div class="col-sm-9">

                                <input
                                    v-model="receipt_data.actual_amount"
                                    type="text"
                                    class="form-control"
                                    id="actual_amount"
                                    required
                                    :placeholder="$t('receipt.actual_amount')"
                                    @input="getExcesCash()"
                                    :disabled="this.$route.params.id == 0 ? false : true"
                                    />

                            </div>

                        </div>

                        <!-- END - date_issued From -->

                    </div>



                    <div class="col-md-6">

                        <!-- BEGIN - Month From -->

                        <div class="form-group">

                            <label for="name" class="col-sm-3 control-label">{{$t('receipt.excess_cash')}}</label>

                            <div class="col-sm-9">

                                <input style="width: 100%;" v-model="receipt_data.excess_cash" type="text" class="form-control"
                                 id="excess_cash" :placeholder="$t('receipt.excess_cash')" :disabled="true" >

                            </div>

                            <!-- /.input group -->

                        </div>

                        <!-- END - Month From -->

                    </div>



                    <div class="col-md-6" >

                        <!-- BEGIN - due_date From -->

                        <div class="form-group">

                            <label for="name" class="col-sm-3 control-label">Bằng Hình Thức</label>

                            <div class="col-sm-9">

                                <div class="input-group date">

                                    <div class="input-group-addon">

                                        <i class="glyphicon glyphicon-registration-mark"></i>

                                    </div>

                                    <select v-model="receipt_data.payments_type" class="form-control" :disabled="this.$route.params.id == 0 ? false : true">
                                        <option
                                            v-for="payment in payments_list"
                                            v-bind:value="payment.id"
                                            :key="payment.id"
                                        >{{ $t(payment.text) }}</option>
                                    </select>

                                </div>

                            </div>

                            <!-- /.input group -->

                        </div>

                        <!-- END - due_date From -->

                    </div>


                    <div class="col-md-6">

                        <!-- BEGIN - Month From -->

                        <div class="form-group">

                            <label for="name" class="col-sm-3 control-label">{{$t('receipt.user_created')}}</label>

                            <div class="col-sm-9">

                                <input style="width: 100%;" v-model="receipt_data.user_created_full_name" type="text" class="form-control" 
                                    id="user_created" :placeholder="$t('receipt.user_created')" :disabled="true">

                            </div>

                            <!-- /.input group -->

                        </div>

                        <!-- END - Month From -->

                    </div>



                </div>



                <div v-show="false">

                    <!-- BEGIN - box-primary -->

                    <hr>

                    <div class="">

                        <!-- BEGIN - box-header -->

                        <div class="box-header">

                            <h3 class="box-title">{{$t('invoice.invoice_info_mainowner')}}</h3>

                        </div>

                        <!-- END - box-header -->



                        <!-- BEGIN - box-body -->

                        <div class="box-body">

                            <div class="col-md-6">

                                <!-- BEGIN - mainowner_fullname From -->

                                <div class="form-group">

                                    <label for="name" class="col-sm-3 control-label">{{$t('invoice.mainowner_fullname')}}</label>

                                    <div class="col-sm-9">

                                        <input v-model="invoiceDataInfo.mainowner_fullname" type="text" class="form-control" :disabled="true">

                                    </div>

                                </div>

                                <!-- END - mainowner_fullname From -->

                            </div>



                            <div class="col-md-6">

                                <!-- BEGIN - mainowner_address From -->

                                <div class="form-group">

                                    <label for="name" class="col-sm-3 control-label">{{$t('invoice.mainowner_address')}}</label>

                                    <div class="col-sm-9">

                                        <input v-model="invoiceDataInfo.mainowner_address" type="text" class="form-control" :disabled="true">

                                    </div>

                                </div>

                                <!-- END - mainowner_address From -->

                            </div>



                            <div class="col-md-6">

                                <!-- BEGIN - mainowner_country From -->

                                <div class="form-group">

                                    <label for="name" class="col-sm-3 control-label">{{$t('invoice.mainowner_country')}}</label>

                                    <div class="col-sm-9">

                                        <input v-model="invoiceDataInfo.mainowner_country" type="text" class="form-control" :disabled="true">

                                    </div>

                                </div>

                                <!-- END - mainowner_country From -->

                            </div>



                            <div class="col-md-6">

                                <!-- BEGIN - mainowner_email From -->

                                <div class="form-group">

                                    <label for="mainowner_email" class="col-sm-3 control-label">{{$t('invoice.mainowner_email')}}</label>

                                    <div class="col-sm-9">

                                        <input v-model="invoiceDataInfo.mainowner_email" type="text" class="form-control" :disabled="true">

                                    </div>

                                </div>

                                <!-- END - mainowner_email From -->

                            </div>



                            <div class="col-md-6">

                                <!-- BEGIN - mainowner_phone From -->

                                <div class="form-group">

                                    <label for="name" class="col-sm-3 control-label">{{$t('invoice.mainowner_phone')}}</label>

                                    <div class="col-sm-9">

                                        <input v-model="invoiceDataInfo.mainowner_phone" type="text" class="form-control" :disabled="true">

                                    </div>

                                </div>

                                <!-- END - mainowner_phone From -->

                            </div>



                            <div class="col-md-6">

                                <!-- BEGIN - mainowner_tax From -->

                                <div class="form-group">

                                    <label for="name" class="col-sm-3 control-label">{{$t('invoice.mainowner_tax')}}</label>

                                    <div class="col-sm-9">

                                        <input v-model="invoiceDataInfo.mainowner_tax" type="text" class="form-control" :disabled="true">

                                    </div>

                                </div>

                                <!-- END - mainowner_tax From -->

                            </div>
                            

                        </div>

                        <!-- END - box-body -->

                    </div>

                    <!-- END - box-primary -->



                </div>



                <hr>

                <div>

                    <div class="">

                        <div class="box-header">

                            <h3 class="box-title">Chi Tiết Phiếu Báo</h3>

                        </div>

                        <div class="box-body">

                            <div class="col-md-6">



                                <!-- BEGIN - user From -->

                                <div class="form-group">

                                    <label for="name" class="col-sm-3 control-label">{{$t('invoice.invoice_number')}}</label>

                                    <div class="col-sm-9">
                                        <input style="width: 100%;" v-model="invoicedata.invoice_number" type="text" class="form-control" id="invoice_number" :placeholder="$t('invoice.invoice_number')" disabled>
                                    </div>

                                </div>

                                <!-- END - user From -->

                            </div>



                            <div class="col-md-6">

                                <!-- BEGIN - resident_address From -->

                                <div class="form-group">

                                    <label for="name" class="col-sm-3 control-label">{{$t('invoice.date_issued')}}</label>

                                    <div class="col-sm-9">

                                        <date-picker v-model="form.date_issued" :config="options" @dp-change="getDueDate" disabled></date-picker>

                                    </div>

                                </div>

                                <!-- END - resident_address From -->

                            </div>

                            <div class="col-md-6">

                                <!-- BEGIN - resident_country From -->

                                <div class="form-group">

                                    <label for="name" class="col-sm-3 control-label">Dịch Vụ Cần Thu</label>

                                    <div class="col-sm-9">

                                        <multiselect v-if="this.$route.params.id == 0" :options="optionService" v-model="optionServiceSelected" tag-placeholder="Add this as new tag" placeholder="Search or Add a Services Available" 
                                        label="name" track-by="id" :multiple="true" @input="onChangeService" :taggable="true" @tag="addService"

                                            :disabled="disabledOptionService ? false : false"></multiselect>

                                        <input v-else v-model="receipt_data.receipt_monthy_services_name" type="text" class="form-control" id="receipt_monthy_services_name" :disabled="true" >

                                    </div>

                                </div>

                                <!-- END - resident_country From -->

                            </div>



                            <div class="col-md-6">

                                <!-- BEGIN - Expected Cash (VNĐ) From -->

                                <div class="form-group">

                                    <label for="name" class="col-sm-3 control-label">{{$t('receipt.expectd_amount_title')}}</label>

                                    <div class="col-sm-9">

                                        <input v-model="receipt_data.expected_amount_show" type="text" class="form-control" :disabled="true">

                                    </div>

                                </div>

                                <!-- END - Expected Cash (VNĐ) From -->

                            </div>


                        </div>

                    </div>

                </div>



                

        <div class="box-footer">
            <button
                type="button"
                class="btn btn-labeled btn-danger"
                @click="cancelReceiptList"
                style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
            > 
            <span class="btn-label">
                <i class="fa fa-mail-reply"></i>
            </span>{{$t('common.back')}}</button>

            <button
                v-show="!isSaveReceipt()"
                type="button"
                class="btn btn-labeled btn-warning pull-right"
                @click="showPrintPdf"
                style="margin-right: 5px;"
                >
                <span class="btn-label">
                    <i class="glyphicon glyphicon-print"></i>
                </span>{{$t('common.printPdf')}}
            </button>

            <button
                    v-show="isSaveReceipt()"
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="saveReceipt"
                    style="margin-right: 5px;"
                >
                <span class="btn-label">
                    <i class="glyphicon glyphicon-ok"></i>
                </span>{{$t('common.save')}}
            </button>

            


            </div>
        </form>
    </div>

    <lte-modal v-show="isModalVisible" @onConfirm="onConfirm" @close="closeModal" v-for="obj in objModal" :key="obj.id" :item="obj"></lte-modal>

    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
    <router-view></router-view>
</div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import {
    mapGetters,
    mapActions
} from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import Multiselect from "vue-multiselect";
import moment from "moment";
import LTEModal from "@/components/LTEModal.vue";
import utils from '@/lib/utils';
import Loading from "vue-loading-overlay"
import i18n from '../../lang'
import constantsData from "../../lib/constantsData";


export default {
    name: "ReceiptAdd",
    data() {
        return {
            receipt_data: {
                id : 0,
                receipt_code: "",
                expected_amount: 0,
                expected_amount_show: 0,
                actual_amount: 0,
                user_created: "",
                user_created_full_name: "",
                date_created: new Date(),
                excess_cash: 0,
                payments_type: 1,
                invoice_id: 0,
                monthy_services: [],
                receipt_monthy_services_name: "",
                payer: ""
            },
            isPrintPdf: false,
            payments_list: constantsData.paymentsType,

            
            // data for show list service Usage
            items: [],
            // MultiSelect Service availabe
            optionServiceSelected: [{
                "name": "All",
                "id": 0
            }], //[{ name: 'Javascript', code: 'js' }]
            optionService: [{
                "name": "All",
                "id": 0
            }
            ], //[{"name":"Vue.js","code":"vu"},{"name":"Javascript","code":"js"},{"name":"Open Source","code":"os"}],
            disabledOptionService: true,
            service_usage_list: [],
            service_usage_list_issued_basic: [],

            form: {
                reciept_date_issued: new Date(),
                date_issued: new Date(),
                date_paid: null,
                service: null,
                device: null,
                user: this.$route.params.id,
                due_date: ""
            },
            options: {
                format: "DD-MM-YYYY"
            },
            actionType: "",

            // ---- Apartment ----
            optionApartmentList: [{
                value: null,
                text: "Select One",
                apartment_id: null
            }], //[{"value":1,"text":"Loi"},{"value":2,"text":"Loc"},{"value":3,"text":"Tuan"},{"value":4,"text":"Hung"},{"value":5,"text":"Hau"}]
            optionApartmentSelected: null,
            apartmentDisabledList: true,
            // ---- Apartment ----

            // ---- User ----
            optionUserList: [{
                value: null,
                text: "Select One"
            }],
            userDisabledList: true,
            // ---- User ----

            apartmentMonthlyUsageList: [], //[{"value":1,"text":"Loi"},{"value":2,"text":"Loc"},{"value":3,"text":"Tuan"},{"value":4,"text":"Hung"},{"value":5,"text":"Hau"}]

            // Status Invoice List
            statusList: [{
                value: null,
                text: "Select One"
            }], //[{"value":1,"text":"Issue"},{"value":2,"text":"Paid"},{"value":3,"text":"Cancelled"}]
            statusSelected: null,
            disabledStatusList: false,

            itemStatusList: [],
            statusListFull: [],

            pagetitle: 'invoice.newinvoice',
            show: false,
            invoicedata: {
                id: 0,
                invoice_number: "",
                invoice_user: null,
                invoice_status: 2, // set default is Issued
                date_issued: new Date(),
                date_paid: new Date(),
                due_date: new Date(),
                apartment_id: "",
                other_details: "",
                mainowner: "",

                banktransfer: {
                    account_no: "",
                    account_name: "",
                    transferring_content: "",
                    contact_us: ""
                },

                accountingPeriod: "",

                apartment_code:""
            },
            invoiceDataInfo: {
                mainowner_fullname: "",
                mainowner_address: "",
                mainowner_email: "",
                mainowner_country: "",
                mainowner_phone: "",
                mainowner_tax: "",

                resident_fullname: "",
                resident_address: "",
                resident_email: "",
                resident_country: "",
                resident_phone: "",
                resident_tax: "",
            },

            isModalVisible: false,
            objModal: [{
                title: 'invoice.modaltitle',
                body: 'invoice.modalbody',
                buttonNo: 'common.cancel',
                buttonYes: 'common.confirm',
                styleType: "default"
            }],

            status: {
                Open: {
                    key: 1,
                    value: "Open"
                },
                Issued: {
                    key: 2,
                    value: "Issued"
                },
                Paid: {
                    key: 3,
                    value: "Paid"
                },
                Cancelled: {
                    key: 4,
                    value: "Cancelled"
                },
                Partial_Paid: {
                    key: 5,
                    value: "Partial Paid"
                },
            },

            Error: {
                invoice_user: "Customer is not empty",
                invoice_status: "Status is not empty",
                apartment_id: "The Apartment is not empty",
                accountingPeriod: "The Month is not empty",
                item: "List service usage is not empty"
            },

            resident_list: [],
            periodDisabledList: false,
            objApartment : null,
            isLoading: false
        };
    },
    watch: {
        GET_LANG: function() {
            this.get_invoice_status_list();
        },

        // watch customer detail
        INVOICE_DETAIL_DATA: async function() {
            let id = this.$route.params.id;

            this.invoicedata.invoice_number = this.INVOICE_DETAIL_DATA.invoice_number;

            if (parseInt(id) !== 0) {
                return;
            }

            this.service_usage_list_issued_basic = this.INVOICE_DETAIL_DATA.service_usage_list.filter(
                item => item.invoice_status.status_code == "I").map(e => e.service.id);

            this.invoicedata.invoice_status = this.INVOICE_DETAIL_DATA.invoice_status.id;
            this.invoicedata.other_details = this.INVOICE_DETAIL_DATA.other_details;

            this.invoicedata.apartment_code = this.INVOICE_DETAIL_DATA.apartment.apartment_code;
            this.invoicedata.invoice_user_name = this.INVOICE_DETAIL_DATA.user.apartment_code;

            // Thông Tin Xuất Hóa Đơn Tới
            if (this.INVOICE_DETAIL_DATA.invoice_to_company_flag) {
                // Company
                this.invoiceDataInfo.resident_fullname =
                    this.INVOICE_DETAIL_DATA.user.company_name + " - (C) ";
                // this.invoiceDataInfo.resident_fullname =
                //     this.INVOICE_DETAIL_DATA.user.company_name;
                this.invoiceDataInfo.resident_tax = this.INVOICE_DETAIL_DATA.user.company_tax_code;
                this.invoiceDataInfo.resident_address = this.INVOICE_DETAIL_DATA.user.company_address;
            } else {
                // Customer
                this.invoiceDataInfo.resident_fullname =
                    this.INVOICE_DETAIL_DATA.user.name + " - (P) ";
                // this.invoiceDataInfo.resident_fullname =
                //     this.INVOICE_DETAIL_DATA.user.name;
                this.invoiceDataInfo.resident_tax = this.INVOICE_DETAIL_DATA.user.personal_tax_code;
                this.invoiceDataInfo.resident_address = this.INVOICE_DETAIL_DATA.apartment.apartment_code;
            }
            this.invoiceDataInfo.resident_email = this.INVOICE_DETAIL_DATA.user.email
            this.invoiceDataInfo.resident_country = this.INVOICE_DETAIL_DATA.user.country
            this.invoiceDataInfo.resident_phone = this.INVOICE_DETAIL_DATA.user.phone


            if (this.INVOICE_DETAIL_DATA.date_issued == null) {
                this.form.date_issued = new Date();
            } else {
                this.form.date_issued = utils.formatSqlDate(this.INVOICE_DETAIL_DATA.date_issued, null, "DD-MM-YYYY");
            }
            this.invoicedata.date_issued = this.INVOICE_DETAIL_DATA.date_issued;
            let due_date = null;
            if (this.INVOICE_DETAIL_DATA.due_date == null) {
                if (this.INVOICE_DETAIL_DATA.date_issued == null) {
                    due_date = new Date(
                        this.form.date_issued.getFullYear(),
                        this.form.date_issued.getMonth() + 1,
                        5
                    );
                    //this.form.due_date = utils.formatSqlDate(due_date, null, "DD-MM-YYYYThh:mm")
                    this.form.due_date = due_date;
                } else {
                    due_date = moment(this.INVOICE_DETAIL_DATA.due_date).set("date", 5).add(1, "M").format("DD-MM-YYYYThh:mm");
                    this.form.due_date = this.INVOICE_DETAIL_DATA.due_date;
                }
            } else {
                due_date = this.INVOICE_DETAIL_DATA.due_date;
                this.form.due_date = utils.formatSqlDate(due_date, null, "DD-MM-YYYYThh:mm");
            }

            this.invoicedata.due_date = due_date;
            if (this.INVOICE_DETAIL_DATA.date_paid == null) {
                this.form.date_paid = null;
            } else {
                this.form.date_paid = utils.formatSqlDate(this.INVOICE_DETAIL_DATA.date_paid, null, "DD-MM-YYYY");
            }
            this.invoicedata.date_paid = this.INVOICE_DETAIL_DATA.date_paid;

            // Process service_usage_list
            // this.optionService = [];

            if (this.INVOICE_DETAIL_DATA.invoice_to_company_flag) {
                // Company
                this.invoicedata.invoice_user = "C_" + this.INVOICE_DETAIL_DATA.client + "_" + this.INVOICE_DETAIL_DATA.invoice_to_company
            } else {
                // User
                this.invoicedata.invoice_user = "P_" + this.INVOICE_DETAIL_DATA.client
                this.invoiceDataInfo.resident_address = this.INVOICE_DETAIL_DATA.apartment.apartment_code;
            }

            this.invoicedata.apartment_id = this.INVOICE_DETAIL_DATA.apartment_id;
            this.invoicedata.accountingPeriod = this.INVOICE_DETAIL_DATA.accounting_period;

            // [loitt] - add show banktransfer
            this.invoicedata.banktransfer.account_no = this.INVOICE_DETAIL_DATA.banktransfer ? this.INVOICE_DETAIL_DATA.banktransfer.account_no : '';
            this.invoicedata.banktransfer.account_name = this.INVOICE_DETAIL_DATA.banktransfer ? this.INVOICE_DETAIL_DATA.banktransfer.account_name : '';
            this.invoicedata.banktransfer.transferring_content = this.INVOICE_DETAIL_DATA.banktransfer ?  this.INVOICE_DETAIL_DATA.banktransfer.transferring_content : '';
            this.invoicedata.banktransfer.contact_us = this.INVOICE_DETAIL_DATA.banktransfer ? this.INVOICE_DETAIL_DATA.banktransfer.contact_us : '';

            // await this.onChangeApartment(this.invoicedata.apartment_id)
            // this.onChangeUser(this.invoicedata.invoice_user)
            this.bindingCustomer(this.INVOICE_DETAIL_DATA.apartment)

            this.invoicedata.total_fees = 0;
            this.items = [];
            this.optionServiceSelected = [];
            this.service_usage_list = [];

            this.INVOICE_DETAIL_DATA.service_usage_list.forEach(v => {
                if(v.invoice_status.status_code == "P"){
                    return
                }

                let vatAmount = utils.vatAmount(v.this_month_value,  v.last_month_value, v.vat, v.price_unit);

                let data = {
                    service_usage_id: v.id,

                    service_name: v.service.service_name,
                    service_code: v.service.service_code,
                    date_from: utils.formatSqlDate(v.date_from, null, "DD/MM/YYYY"),
                    date_to: utils.formatSqlDate(v.date_to, null, "DD/MM/YYYY"),
                    last_value: v.last_month_value,
                    current_value: v.this_month_value,
                    price_unit: v.price_unit,
                    vat: v.vat, // store db
                    vatAmount: vatAmount[0], // display
                    apartment_id: v.apartment_id,
                    total_fee: vatAmount[1],
                    total_all: vatAmount[2],
                    status: v.invoice_status,
                    show_action: false
                };

                if(v.invoice_status.id == 3){
                    data['_rowVariant'] = 'success'
                    data['isReadOnly'] = true
                } else {
                    data['isReadOnly'] = false
                }

                let dataOptionServiceUsage = {
                    name: v.service.service_name,
                    service_id: v.service.id
                };

                const found = this.optionService.some(
                    el => el.service_id === v.service.id
                );

                if (!found) {
                    if(this.service_usage_list_issued_basic.includes(dataOptionServiceUsage.service_id)){
                        this.optionService.push(dataOptionServiceUsage);
                        this.optionServiceSelected.push(dataOptionServiceUsage);
                    }
                }

                // always add id to service_usage_list (id ~ service_usage_id)
                this.service_usage_list.push(v.id);
                // always add total_fees to service_usage_list (total_fees ~ total_fees)
                this.invoicedata.total_fees += data['total_all'];

                // Load to table Service Usage
                this.items.push(data);
            });

            // [loitt] - fixed makeRoundNumber
            this.invoicedata.total_fees = utils.makeRoundNumber(this.invoicedata.total_fees)

            let dataSummary = {
                service_usage_id: "",
                service_name: "",
                service_code: "",
                date_from: "",
                date_to: "",
                last_value: "",
                current_value: "Tổng cộng",
                total_all: this.invoicedata.total_fees,
                show_action: false,
                status: null
            };
            this.items.push(dataSummary);

            this.receipt_data.expected_amount = this.invoicedata.total_fees
            this.receipt_data.expected_amount_show = this.formatTotalFee(this.invoicedata.total_fees)
            this.receipt_data.monthy_services = this.service_usage_list

            // default payer = resident_fullname
            this.receipt_data.payer = this.invoiceDataInfo.resident_fullname
        }
    },
    computed: {
        functionExample: function() {
            return "";
        },
        ...mapGetters(
            ["INVOICE_DETAIL_DATA", "GET_SNACK_BAR", "GET_RECEIPT_DATA",
            "GENERATE_INVOICE_NUMBER",
            "GET_ACCOUNT_DATA",
            "GET_LANG"
            ]
        )
    },
    methods: {
        isSaveReceipt(){
            let id = this.$route.params.id;
            return  parseInt(id) === 0
        },
        getExcesCash(){
            let excess_cash = this.receipt_data.actual_amount - this.receipt_data.expected_amount
            this.receipt_data.excess_cash = this.formatTotalFee((excess_cash < 0) ? 0 : excess_cash)
        },
        get_invoice_status_list(){
            this.statusList = []
            this.itemStatusList = []
            this.statusListFull = []
            this.GET_INVOICE_STATUS_LIST().then(
                function(res) {
                    let result = res.data;
                    result.results.forEach(v => {
                        this.statusListFull.push(v);

                        let data = {
                            text: this.getStatusName(v),
                            value: v.id
                        };
                        if (v.status_description == this.status.Issued.value || v.status_description == this.status.Paid.value) {
                            this.statusList.push(data);
                            this.itemStatusList.push(data);
                        } else if (v.status_description == this.status.Partial_Paid.value) {
                            this.statusList.push(data);
                        }
                    });
                }.bind(this)
            );
        },
        getStatusName(v){
                let language_status_name = 'invoice.invoice_status.' + v.status_code
                let status_name = this.$t(language_status_name)//invoice.invoice_status.status_description;
                if (utils.isEnglishLanguage(i18n.locale)) {
                    return status_name
                } else {
                    return status_name
                }
        },
        formatTotalFee: function(total_fee) {
            if(total_fee != undefined){
                return utils.formatNumber(utils.makeRoundNumber(total_fee))
            }
        },
        getDueDate(e) {
            // let due_date = e.date.set("date", 5).add(1, "M").format("DD-MM-YYYY");
            // this.form.due_date = due_date;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        ...mapActions([
            "ERROR_TOAST",
            "SUCCESS_TOAST",
            "ADD_RECEIPT",
            "GET_INVOICE_DETAIL",
            "GET_RECEIPT_DETAIL",
            // "UPDATE_RECEIPT",
            "GET_INVOICE_STATUS_LIST",
            "GET_APARTMENT_USAGE_LIST",
            "ON_SHOW_TOAST",
            "GENERATE_INVOICE_ID",
            "GET_PROJECT_BANK_TRANSFER"
        ]),
        cancelReceiptList: function() {
            let id = this.$route.params.id;
            if(parseInt(id) === 0){
                this.$router.push({
                name: "InvoiceAdd",
                params: {
                    id: this.receipt_data.invoice_id
                }
                });
            } else {
                this.$router.push({
                    name: "InvoiceList"
                });
            }
        },
        validateData: function() {
            let validatedResult = "OK";

            if(utils.isNull(this.receipt_data.actual_amount)){
                validatedResult = "Tiền Thu Từ Khách Không Được Trống"
            } else if(!utils.isNumeric(this.receipt_data.actual_amount)){
                validatedResult = "Tiền Thu Từ Khách Phải Là Số"
            } else if(this.receipt_data.actual_amount < this.receipt_data.expected_amount){
                validatedResult = "Tiền Thu Từ Khách Phải Lớn Hơn Tiền Cần Thu"
            }

            if(utils.isNull(this.receipt_data.payer)){
                validatedResult = "Khách Hàng Không Được Trống"
            }

            return validatedResult;
        },
        // Generate invoice number by time option 1
        generateInvoiceNumberOption1: function(subObject) {
            let invoiceNumber = subObject + new Date().getTime().toString(36);
            return invoiceNumber;
        },
        // Generate invoice number by time option 2
        generateInvoiceNumberOption2: function(subObject) {
            var date = new Date();
            var components = [
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                date.getHours(),
                date.getMinutes(),
                date.getSeconds(),
                date.getMilliseconds()
            ];
            var id = components.join("");
            return subObject + id;
        },
        generateInvoiceNumberOption3: function(subObject) {
            return this.GENERATE_INVOICE_ID().then(
                function(res) {
                    let result = res.data
                    return result
                })
        },



        addService: function(newTag) {
            // console.log(newTag);
            // const tag = {
            //   name: newTag,
            //   code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            // }
            // this.options.push(tag)
            // this.value.push(tag)
        },

        async onChangeApartment(val) {
            // console.log("onChangeApartment apartment id : " + val);
            if(val == null){
                return;
            }

            // Task 4: Add one field (Ch? S? H?u) at invoice detail screen.
            // const data = {
            //     params: {
            //         page: 1,
            //         apartment: val
            //     }
            // };

            // console.log(JSON.stringify(this.optionApartmentList))
            this.optionApartmentSelected = val
            this.objApartment = null
            this.objApartment = this.optionApartmentList.filter(item => item.value == val)[0].apartment
            // with constructor:
            // apartmentservices: Tất cả dịch vụ
            // resident : Thông tin Căn hộ
            // apartmentMonthlyUsage: Dịch vụ đã sử dụng


            // Binding IN CUSTOMER
            this.bindingCustomer(this.objApartment)

            // reset list
            this.items = []
            // this.optionService = []
            // this.optionServiceSelected = []



            if (val == null) {
                return;
            }

            // ***************************************************
            //              combobox user
            // ***************************************************
            // set default combobox user  is not select
            this.invoicedata.invoice_user = null
            // Load combobox user
            this.loadUser()
            // ***************************************************

            // ***************************************************
            //              combobox service
            // ***************************************************
            // set default combobox service is select ALL
            this.optionServiceSelected = [{
                "name": "All",
                "id": 0
            }]
            // Load combobox service
            this.loadService()
            // ***************************************************

            // Update apartmentMonthlyUsageList - List apartment monthly Usage
            this.apartmentMonthlyUsageList = this.objApartment.apartmentMonthlyUsage

            this.loadServiceUsage(val, null, this.optionServiceSelected, this.$route.params.id)
        },

        bindingCustomer(objApartment){
            let result = objApartment.resident.filter(item => item.isOwner == true || item.isTenant == true);

            let full_name = result[0].resident.last_name + " " + result[0].resident.first_name
            this.invoicedata.mainowner = full_name

            this.invoiceDataInfo.mainowner_fullname = full_name
            this.invoiceDataInfo.mainowner_address = objApartment.code
            this.invoiceDataInfo.mainowner_email = result[0].resident.email
            this.invoiceDataInfo.mainowner_country = result[0].resident.country
            this.invoiceDataInfo.mainowner_tax = result[0].resident.personal_tax_code
            this.invoiceDataInfo.mainowner_phone = result[0].resident.phone
        },

        //
        // [loitt] - Load combobox user - Danh sách Tên Người Xuất
        //
        loadUser(){
            const dataUser = [{
                value: null,
                text: "Select One"
            }];
            // this.invoicedata.invoice_user = null
            this.optionUserList = dataUser;

            // LOAD info User
            let listMonthlyUsageListByUser = this.objApartment.apartmentMonthlyUsage.map(e => e.user);
            // Remove duplicate
            let listUser = this.getUnique(listMonthlyUsageListByUser, "id")
            // console.log(JSON.stringify(this.objApartment))

            listUser.forEach(function(v) {
                let data = {
                    value: "P_" + v.id,
                    text: v.fullname + " - (P)",
                    resident: v
                }
                if(v.id != 0){
                    dataUser.push(data)
                }

                // process for company
                if (v.is_company) {
                    data = {
                        value: "C_" + v.id + "_" + v.company_id,
                        text: v.company_name + " - (C)",
                        resident: v
                    }
                    dataUser.push(data)
                }
            })
            this.optionUserList = dataUser;
        },
        //
        // [loitt] - Load combobox service - Danh sách Dịch Vụ Sử Dụng
        //
        loadService(){
            // LOAD info Service
            let optionService = this.objApartment.apartmentMonthlyUsage.map(e => e.service_details);
            this.optionService = this.getUnique(optionService, "id")

            // All field ALL
            this.optionService.push({
                    "name": "All",
                    "id": 0
                })
        },

        loadServiceUsage(apartment_id, user_id, listService, invoice_id) {
            let listIdService = null
            if (listService != null) {
                listIdService = listService.map(e => e.id);
                // Fixed select All show all service
                if (listIdService.includes(0)) {
                    listIdService = this.optionService.filter((item) => item.id > 0).map(e => e.id);
                }
            }

            this.service_usage_list = []

            this.items = [];

            const dataSearch = [];
            const service_usage_list_service = [];
            this.invoicedata.total_fees = 0
            let total_fees = 0;

            //===================
            if (user_id == null || user_id == "P_null" || user_id == "C_null") {
                user_id = null
            }

            let export_invoice_to = null
            let type_export_invoice_to = null
            if (user_id != null) {
                // 0 :  C: Company - P : Personal
                // 1 :  id invoice to
                // 2 :  id company
                let arrayInvoiceTo = user_id.split("_");
                // always update
                export_invoice_to = arrayInvoiceTo[1]
                type_export_invoice_to = arrayInvoiceTo[0]
            }
            //===================

            this.apartmentMonthlyUsageList.forEach(function(v) {
                if (v.apartment == apartment_id &&
                    (export_invoice_to == null || export_invoice_to == v.user.id) &&
                    (listIdService == null || listIdService.length == 0 || listIdService.includes(v.service))) {

                    let vatAmount = utils.vatAmount(v.this_month_value,  v.last_month_value, v.vat, v.price_unit);
                    let data = {
                        service_usage_id: v.id,
                        service_name: v.service_details.name,
                        service_code: v.service_details.servicecode,
                        date_from: utils.formatSqlDate(v.date_from, null, "DD/MM/YYYY"),
                        date_to: utils.formatSqlDate(v.date_to, null, "DD/MM/YYYY"),
                        last_value: v.last_month_value,
                        current_value: v.this_month_value,
                        price_unit: v.price_unit,
                        vat: v.vat, // store db
                        vatAmount: vatAmount[0], // display
                        status: v.status,
                        total_fee: vatAmount[1],
                        show_action: false
                    };

                    if(v.status.id == 3 || v.last_month_value == v.this_month_value){
                        data['_rowVariant'] = 'success'
                        data['isReadOnly'] = true
                        data['status'] = Object.assign({}, this.statusListFull.filter(item => item.status_code == 'P')[0])
                    } else {
                        data['isReadOnly'] = false
                        data['status'] = Object.assign({}, this.statusListFull.filter(item => item.status_code == 'I')[0])
                    }


                    if (invoice_id == 0 && v.invoice == null) {
                        if (type_export_invoice_to == null) {
                            total_fees = total_fees + v.total_fees
                            service_usage_list_service.push(v.id)
                            // data.status.id = 2 // set default is Issued
                            dataSearch.push(data);
                        } else if (type_export_invoice_to == "C" && v.is_company) {
                            total_fees = total_fees + v.total_fees
                            service_usage_list_service.push(v.id)
                            // data.status.id = 2 // set default is Issued
                            dataSearch.push(data);
                        } else if (type_export_invoice_to == "P" && !v.is_company) {
                            total_fees = total_fees + v.total_fees
                            service_usage_list_service.push(v.id)
                            // data.status.id = 3 // set default is Issued
                            dataSearch.push(data);
                        }
                    } else if (invoice_id != 0 && v.invoice != null) {
                        total_fees = total_fees + data['total_fee']
                        service_usage_list_service.push(v.id)
                        dataSearch.push(data);
                    }

                    // dataSearch.push(data);
                }
            }.bind(this))

            // [loitt] - fixed makeRoundNumber
            total_fees = utils.makeRoundNumber(total_fees)

            // Set summary line
            let dataSummary = {
                service_usage_id: "",
                service_name: "",
                date_from: "",
                date_to: "",
                last_value: "",
                current_value: "Summary",
                status: null,
                total_fee: total_fees,
                show_action: false
            };

            // set total_fees
            this.invoicedata.total_fees = total_fees
            // console.log(total_fees)
            this.receipt_data.expected_amount_show = this.formatTotalFee(this.invoicedata.total_fees)

            this.items = dataSearch
            if (this.items.length > 0) {
                this.service_usage_list = service_usage_list_service
                this.items.push(dataSummary);
            }

            this.onSelected()
        },
        getUnique(arr, comp) {
            const unique = arr
                .map(e => e[comp])
                // store the keys of the unique objects
                .map((e, i, final) => final.indexOf(e) === i && i)
                // eliminate the dead keys & store unique objects
                .filter(e => arr[e]).map(e => arr[e]);

            return unique;
        },
        // [ACTION_02] - Select User
        // 1. Select User - Ex: select user 1
        // 2. Add service to list Services Usage by user selected - Ex: Show list Service (removed duplicate)
        onChangeUser(val) {
            if (val == null ||
                val == "P_null" ||
                val == "C_null") {
                val = null
            }

            this.invoicedata.invoice_user = val
            // let export_invoice_to = null
            if (val != null) {
                // 0 :  C: Company - P : Personal
                // 1 :  id invoice to
                // 2 :  id company
                let arrayInvoiceTo = val.split("_");
                // always update

                // export_invoice_to = arrayInvoiceTo[1]

                let type_export_invoice_to = arrayInvoiceTo[0]

                let result = this.optionUserList.filter(item => item.value == val);
                let full_name = result[0].resident.first_name + " " + result[0].resident.last_name
                this.invoiceDataInfo.resident_fullname = full_name

                this.invoiceDataInfo.resident_email = result[0].resident.email
                this.invoiceDataInfo.resident_country = result[0].resident.country_name
                this.invoiceDataInfo.resident_phone = result[0].resident.phone
                // C: Company - P : Personal
                if (type_export_invoice_to == "C") {
                    this.invoiceDataInfo.resident_tax = result[0].resident.company_tax_code
                    this.invoiceDataInfo.resident_address = result[0].resident.company_address
                } else {
                    this.invoiceDataInfo.resident_address = this.objApartment.code
                    this.invoiceDataInfo.resident_tax = result[0].resident.personal_tax_code
                }
            }

            // [{"id":5,"username":"uuser1","lastname":"1","firstname":"T","fullname":"1 T","email":"admin1@gmail.com","phone":"0"}]


            let apartment_id = this.optionApartmentSelected
            if (apartment_id != null) {
                this.loadServiceUsage(apartment_id, val, this.optionServiceSelected, this.$route.params.id)
            }

        },

        onChangeService(val) {
            if (val.length == 0) {
                this.optionServiceSelected = [{
                    "name": "All",
                    "id": 0
                }]
            }

             if (val.length > 1) {
                let lastedItem = val[val.length - 1]
                if (lastedItem.name == "All") {
                    this.optionServiceSelected = [{
                        "name": "All",
                        "id": 0
                    }]
                } else {
                    val = val.filter(function(item) {
                        return item.name != "All";
                    });

                    if (val.length == this.optionService.length - 1) {
                        this.optionServiceSelected = [{
                            "name": "All",
                            "id": 0
                        }]
                    } else {
                        this.optionServiceSelected = val
                    }
                }

            }

            let list_service_id = null
            if (val.length == 0) {
                list_service_id = this.service_usage_list_issued_basic
            } else {
                list_service_id = val.map((item, index, val) => {
                    return item.service_id
                })
            }

            var service_usage_list = this.INVOICE_DETAIL_DATA.service_usage_list.filter(function(item) {
                return list_service_id.includes(item.service_id);
                });

            this.receipt_data.monthy_services = service_usage_list.map((item) => {
                    return item.id
                })

            let total_fees = 0
            service_usage_list.forEach(v => {
                let vatAmount = utils.vatAmount(v.this_month_value,  v.last_month_value, v.vat, v.price_unit);
                let total_all = vatAmount[2]
                total_fees += total_all
            })

            this.receipt_data.expected_amount = total_fees
            this.receipt_data.expected_amount_show = this.formatTotalFee(total_fees)

            this.getExcesCash()
        },
        onSelected: function() {
            let list_status_id = []
            for (var i = 0; i < this.items.length - 1; i++) {
                let obj_status = Object.assign({}, this.statusListFull.filter(e => e.id == this.items[i].status.id)[0])
                list_status_id.push(obj_status.id)
            }
            if (list_status_id.every(x => x == this.status.Paid.key)) {
                // All Paid
                this.invoicedata.invoice_status = this.status.Paid.key
            } else if (list_status_id.every(x => x == this.status.Issued.key)) {
                this.invoicedata.invoice_status = this.status.Issued.key
            } else {
                this.invoicedata.invoice_status = this.status.Partial_Paid.key
            }

        },
        onConfirm: function() {
            this.isModalVisible = false;
        },
        showPrintPdf: function() {
            let name = "ReceiptPdf_TM"
            if(this.receipt_data.payments_type != 1)
                name = "ReceiptPdf_CK"

            let routeData = this.$router.resolve({
                name: name,
                params: {
                    id: this.receipt_data.id
                }
            });
            window.open(routeData.href, "_blank");
        },
        // Process save and update invoice
        saveReceipt: function(event) {
            let result = this.validateData();
            if (result == "OK") {
                // receipt_code: gender from db
                // expected_amount: get from user input
                // actual_amount: get from user input
                // invoice: get from param
                // monthy_services: get from User input
                // user_created: get from user login
                // receipt_type: get from user input
                let data = {
                    expected_amount: this.receipt_data.expected_amount,
                    actual_amount: this.receipt_data.actual_amount,
                    invoice: this.receipt_data.invoice_id,
                    monthy_services: this.receipt_data.monthy_services.join(","),
                    user_created: this.GET_ACCOUNT_DATA.id,
                    receipt_type: this.receipt_data.payments_type,
                    payer: this.receipt_data.payer
                };

                if (parseInt(this.receipt_data.id) == 0) {
                    this.ADD_RECEIPT(data).then(
                        function(res) {
                            this.SUCCESS_TOAST();
                            this.$router.push({
                                name: "ReceiptAdd",
                                params: {
                                    id: res.id,
                                }
                            });
                            this.receipt_data.payments_type = res.receipt_type
                            this.receipt_data.id = res.id
                            this.receipt_data.receipt_monthy_services_name = res.receipt_monthy_services_name.name;
                        }.bind(this)
                    )
                    .catch(
                        function(error) {
                            this.ON_SHOW_TOAST({
                                message: error,
                                styleType: "danger"
                            })
                        }.bind(this)
                    );
                } else {
                    // this.UPDATE_RECEIPT(data).then(
                    //     function() {
                    //         this.$router.push({
                    //             name: "InvoiceList"
                    //         });
                    //     }.bind(this)
                    // )
                    // .catch(
                    //     function(error) {
                    //         this.ON_SHOW_TOAST({
                    //             message: error,
                    //             styleType: "danger"
                    //         })
                    //     }.bind(this)
                    // );
                }
            } else {
                this.ON_SHOW_TOAST({
                    message: result,
                    styleType: "danger"
                })
            }
        }
    },
    created() {
        this.GET_PROJECT_BANK_TRANSFER().then(
            function(res){
                let data = res.data.data[0]
                this.invoicedata.banktransfer.account_no = data.bank_account_no
                this.invoicedata.banktransfer.account_name = data.bank_account_name
                this.invoicedata.banktransfer.transferring_content = data.bank_transferring_content
                this.invoicedata.banktransfer.contact_us = data.bank_contact_us
            }.bind(this)
        ).catch(
          function() {
              this.isLoading = false
          }.bind(this)
        );
    },
    async mounted() {
        this.isLoading = true

        this.receipt_data.expected_amount = this.invoicedata.total_fees

        // 2. GET GET_APARTMENT_USAGE_LIST - Mã Căn
        // 3. SELECT Mã Căn - onChangeApartment
        // 4. SELECT Tên Người Xuất - onChangeUser
        // 5. SELECT Dịch Vụ Sử Dụng - onChangeService

        // update due date
        let due_date = new Date(
            this.form.date_issued.getFullYear(),
            this.form.date_issued.getMonth() + 1,
            5
        );
        //this.form.due_date = utils.formatSqlDate(due_date, null, "DD-MM-YYYYThh:mm")
        this.form.due_date = due_date;
        this.invoicedata.due_date = due_date;

        // Set data for select INVOICE_STATUS - [ACTION_01]
        this.get_invoice_status_list();

        // //////////////////////////////
        // Add or Update data
        // //////////////////////////////
        let id = this.$route.params.id;

        if (parseInt(id) !== 0) {
            await this.GET_RECEIPT_DETAIL({ id: id }).then(
                function(res) {
                    // monthy_services
                    this.receipt_data.id = res.id;
                    this.receipt_data.receipt_code = res.receipt_code;
                    this.receipt_data.expected_amount = res.expected_amount;

                    this.receipt_data.expected_amount_show = this.formatTotalFee(res.expected_amount);
                    this.receipt_data.actual_amount = this.formatTotalFee(res.actual_amount);
                    this.receipt_data.excess_cash = this.formatTotalFee(res.actual_amount -  res.expected_amount);

                    this.receipt_data.user_created = res.user_created;
                    this.receipt_data.user_created_full_name = utils.getFullName(
                        res.user_first_name,
                        res.user_last_name,
                        i18n.locale
                    );
                    this.invoiceDataInfo.resident_fullname = res.apartment.owner_apartment
                    this.receipt_data.date_created = res.date_created;
                    this.receipt_data.payments_type = res.receipt_type;
                    this.receipt_data.receipt_monthy_services_name = res.receipt_monthy_services_name.name;
                    this.receipt_data.invoice_id = res.invoice;

                    this.GET_INVOICE_DETAIL({
                        id: this.receipt_data.invoice_id
                    });
                    this.show = true;
                    // this.disabledStatusList = false;
                    // this.userDisabledList = false;
                    // this.apartmentDisabledList = false;

                    this.disabledOptionService = false;
                    this.periodDisabledList = false
                }.bind(this)
            ).catch(
                function(error) {
                    this.ERROR_TOAST()
                }.bind(this)
            );
        } else {
            this.receipt_data.user_created_full_name = utils.getFullName(
                this.GET_ACCOUNT_DATA.firstname,
                this.GET_ACCOUNT_DATA.lastname,
                i18n.locale
            );
            this.receipt_data.invoice_id = this.$route.query.invoice_id
            // console.log(this.receipt_data.invoice_id)
            if(this.receipt_data.invoice_id == undefined){
            this.ON_SHOW_TOAST({
                                message: "Giấy Báo Tồn Tại!!!",
                                styleType: "danger"
                            })
                            return;
            }

            this.receipt_data.payments_type = 1
            await this.GET_INVOICE_DETAIL({
                id: this.receipt_data.invoice_id
            });
            this.show = true;

            this.apartmentMonthlyUsageList = []
            this.GET_APARTMENT_USAGE_LIST().then(
                function(res) {
                    let result = res.data;
                    result.forEach(v => {
                        let data = {
                        text: v.apartment_code,
                        value: v.id,
                        apartment:v
                        };
                        this.optionApartmentList.push(data);
                    });
                    this.isLoading = false
                }.bind(this)
            );

            // [ACTION_ADD_RECEIPT] - [ACTION_01]
            this.invoicedata.invoice_number = await this.generateInvoiceNumberOption3();
            // Set disable
            this.userDisabledList = true;
            this.apartmentDisabledList = true;
            this.disabledStatusList = false;
            this.disabledOptionService = true;

            this.optionApartmentSelected = null;
            this.periodDisabledList = true
        }

        this.isLoading = false
    },
    components: {
        "lte-core-alert": LTECoreAlert,
        "date-picker": datePicker,
        Multiselect,
        "lte-modal": LTEModal,
        loading: Loading
    }
};
</script>

<style scoped>
.table-success {
    border-color:#8fd19e;
    background-color:#ddd
}

.btn-owner {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #337ab7;
  border-color: #2e6da4;
}

.btn-tenant {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #f0ad4e;
  border-color: #eea236;
}

.btn-null {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #5cb85c;
  border-color: #4cae4c;
}

/* Tooltip container */
.tooltip-button {
  display: inline;
  position: relative;
}

.tooltip-button:hover:after {
  background: #333;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  bottom: 26px;
  color: #fff;
  content: attr(title);
  left: 20%;
  padding: 5px 15px;
  position: absolute;
  z-index: 98;
  width: 220px;
}

.tooltip-button:hover:before {
  border: solid;
  border-color: #333 transparent;
  border-width: 6px 6px 0 6px;
  bottom: 20px;
  content: "";
  left: 50%;
  position: absolute;
  z-index: 99;
}
.hidden {
  display: none;
}
.label-darkcyan {
  background-color: darkcyan !important;
}
.label-crimson {
  background-color: crimson !important;
}
.label-darkblue {
  background-color: darkblue !important;
}

</style>



// WEBPACK FOOTER //
// src/views/Receipt/ReceiptAdd.vue